(function () {
  'use strict';

  function buildPayload(params) {
    return Object.assign(
      {
        event_origin: 'aballe_theme',
        page_path: window.location.pathname,
        page_location: window.location.href,
        page_title: document.title,
        transport_type: 'beacon',
      },
      params || {}
    );
  }

  function track(eventName, params) {
    if (!eventName) return null;

    var payload = buildPayload(params);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }

    return payload;
  }

  function detectTrackedForm(form) {
    var newsletterTagField = form.querySelector('input[name="contact[tags]"]');
    var newsletterTags = newsletterTagField ? newsletterTagField.value || '' : '';
    var horologiumFlagField = form.querySelector('input[name="contact[horologium_inquiry]"]');

    if (form.id === 'ContactForm') {
      return {
        eventName: 'private_appointment_inquiry_submit',
        form_id: form.id || '',
        form_location: 'contact_page',
        form_context: 'private_appointment',
      };
    }

    if (form.id === 'horologium-form' || horologiumFlagField) {
      return {
        eventName: 'horologium_inquiry_submit',
        form_id: form.id || '',
        form_location: 'horologium_product',
        form_context: 'horologium_inquiry',
      };
    }

    if (newsletterTags.indexOf('newsletter') !== -1 || form.classList.contains('newsletter-form')) {
      var formLocation = 'newsletter_section';

      if (form.id === 'ContactFooter') {
        formLocation = 'footer_newsletter';
      } else if (form.closest('.email-signup-banner')) {
        formLocation = 'email_signup_banner';
      }

      return {
        eventName: 'collector_email_capture',
        form_id: form.id || '',
        form_location: formLocation,
        form_context: 'collector_email',
      };
    }

    return null;
  }

  function trackTrackedFormSubmit(form) {
    if (!form) return false;

    var trackedForm = detectTrackedForm(form);
    if (!trackedForm || !trackedForm.eventName) return false;

    if (form.dataset.aballeTracked === '1') return false;

    form.dataset.aballeTracked = '1';
    track(trackedForm.eventName, {
      form_id: trackedForm.form_id,
      form_location: trackedForm.form_location,
      form_context: trackedForm.form_context,
    });
    return true;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (!form || form.tagName !== 'FORM') return;
      if (form.getAttribute('data-aballe-track-manual') === 'true') return;

      trackTrackedFormSubmit(form);
    },
    true
  );

  window.AballeAnalytics = window.AballeAnalytics || {};
  window.AballeAnalytics.track = track;
  window.AballeAnalytics.trackTrackedFormSubmit = trackTrackedFormSubmit;
  window.AballeAnalytics.detectTrackedForm = detectTrackedForm;
})();
